const notReport = email => email.actionMethod !== 'send_report'

const notResend = email => !email.actionMethod.startsWith('resend_')

const removeEmails = emails => emails.filter(notReport).filter(notResend)

export default removeEmails
